// i18n.js — Translation strings for AI Resepsjonen portal
// language: "no" = Norwegian (default), "en" = English

export const translations = {
  no: {
    // Nav / Sidebar
    nav_overview: 'Oversikt',
    nav_calls: 'Samtaler',
    nav_contacts: 'Kontakter',
    nav_analytics: 'Innsikt',
    nav_settings: 'Innstillinger',
    nav_companies: 'Bedrifter',
    nav_users: 'Brukere',
    nav_finance: 'Økonomi',
    nav_integrations: 'Integrasjoner',
    nav_logout: 'Logg ut',

    // Dashboard
    dash_title: 'Oversikt',
    dash_total_calls: 'Totale samtaler',
    dash_avg_score: 'Gjennomsnittlig lead-score',
    dash_avg_duration: 'Gjennomsnittlig samtaletid',
    dash_appointments: 'Avtaler booket',
    dash_hot_leads: 'Varme leads',
    dash_recent_calls: 'Siste samtaler',
    dash_no_calls: 'Ingen samtaler ennå',
    dash_lead_score: 'Lead-score',
    dash_intent: 'Hensikt',
    dash_duration: 'Varighet',
    dash_caller: 'Ringer',
    dash_textbacks: 'Text-backs sendt',
    dash_calls_per_day: 'Samtaler per dag',
    dash_view_all: 'Se alle',
    dash_quick_latest_call: 'Nyeste samtale',
    dash_quick_latest_call_sub: 'Se siste anrop',
    dash_quick_export_week: 'Eksporter uke',
    dash_quick_export_week_sub: 'Last ned CSV',
    dash_quick_contacts: 'Alle kontakter',
    dash_quick_contacts_sub: 'Bla i kontaktlista',
    dash_quick_analytics: 'Analyse',
    dash_quick_analytics_sub: 'Trender og innsikt',
    dash_today_calls: 'Dagens samtaler',
    upgrade: 'Oppgrader',

    // Calls
    calls_title: 'Samtaler',
    calls_search: 'Søk i samtaler...',
    calls_filter_all: 'Alle',
    calls_filter_hot: 'Varme leads',
    calls_filter_appt: 'Avtaler',
    calls_no_results: 'Ingen samtaler funnet',
    calls_score: 'Score',
    calls_intent: 'Hensikt',
    calls_duration: 'Varighet',
    calls_date: 'Dato',
    calls_caller: 'Ringer',
    calls_summary: 'Sammendrag',
    calls_transcript: 'Transkripsjon',
    calls_back: 'Tilbake',
    calls_export: 'Eksporter CSV',
    calls_exporting: 'Eksporterer...',
    calls_export_success: 'CSV eksportert',
    calls_export_error: 'Kunne ikke eksportere CSV',

    // Contacts
    contacts_title: 'Kontakter',
    contacts_search: 'Søk etter navn, telefon eller epost...',
    contacts_add: 'Legg til kontakt',
    contacts_import: 'Importer CSV',
    contacts_no_results: 'Ingen kontakter funnet',
    contacts_name: 'Navn',
    contacts_phone: 'Telefon',
    contacts_email: 'Epost',
    contacts_calls: 'Samtaler',
    contacts_last_call: 'Siste samtale',
    contacts_score: 'Score',
    contacts_tags: 'Tagger',
    contacts_notes: 'Notater',
    contacts_history: 'Samtalhistorikk',
    contacts_back: 'Tilbake',
    contacts_save: 'Lagre',
    contacts_export: 'Eksporter CSV',
    contacts_exporting: 'Eksporterer...',
    contacts_export_error: 'Kunne ikke eksportere kontakter',
    contacts_total: '{count} kontakter totalt',

    // Analytics
    analytics_title: 'Analyse',
    analytics_period: 'Periode',
    analytics_7d: '7 dager',
    analytics_30d: '30 dager',
    analytics_90d: '90 dager',
    analytics_calls_over_time: 'Samtaler over tid',
    analytics_by_intent: 'Etter hensikt',
    analytics_by_score: 'Etter score',
    analytics_top_services: 'Mest etterspurte tjenester',
    analytics_conversion: 'Konverteringsrate',
    analytics_no_data: 'Ingen data for valgt periode',

    // Settings
    settings_title: 'Innstillinger',
    settings_business: 'Bedriftsinformasjon',
    settings_hours: 'Åpningstider',
    settings_services: 'Tjenester',
    settings_pricing: 'Priser',
    settings_notifications: 'Varsler',
    settings_sms: 'SMS-varsel',
    settings_email_notif: 'E-postvarsel',
    settings_save: 'Lagre',
    settings_saved: 'Lagret',
    settings_error: 'Feil ved lagring',

    // Suggestions
    suggestions_title: 'Oppfølgingsforslag',
    suggestions_analyzing: 'Analyserer samtale...',
    suggestions_markDone: 'Fullført',
    suggestions_dismiss: 'Avvis',
    suggestions_pending: 'oppfølginger venter',
    suggestions_noPending: 'Ingen ventende oppfølginger',

    // ROI
    roi_title: 'ROI Rapport',
    roi_subtitle: 'Se verdien AI-resepsjonisten din skaper',
    roi_calls_handled: 'Samtaler håndtert av AI',
    roi_hours_saved: 'Timer spart',
    roi_cost_saved: 'Estimert kostnad spart',
    roi_missed_recovered: 'Tapte anrop gjenvunnet',
    roi_this_month: 'denne måneden',
    roi_total: 'totalt',
    roi_trend: 'Månedlig trend (siste 6 måneder)',
    roi_suggestions_done: 'Oppfølginger fullført',
    roi_suggestions_dismissed: 'Oppfølginger avvist',
    roi_suggestions_pending: 'Venter',
    roi_hourly_rate_note: 'Beregnet med',
    roi_hourly_rate_suffix: '/time',
    roi_edit_settings: 'Endre i Innstillinger',
    roi_share: 'Del rapport',
    roi_nav: 'ROI',
    roi_hourly_rate_label: 'Timepris (USD)',
    product_name: 'AI Resepsjonen',

    // Login
    login_headline: 'Din AI-resepsjonist,<br/>alltid tilgjengelig.',
    login_subtext: 'Administrer samtaler, leads og avtaler fra ett sted. Se hva som skjer med bedriften din i sanntid.',
    login_stat_always: 'Alltid på',
    login_stat_satisfied: 'Fornøyde kunder',
    login_stat_calls: 'Samtaler håndtert',
    login_title: 'Logg inn',
    login_subtitle: 'Skriv inn din e-post og passord for å logge inn.',
    login_email: 'E-post',
    login_email_placeholder: 'din@epost.no',
    login_password: 'Passord',
    login_password_placeholder: 'Ditt passord',
    login_remember: 'Husk meg',
    login_forgot: 'Glemt passord?',
    login_forgot_alert: 'Kontakt oss for å tilbakestille passordet ditt.',
    login_button: 'Logg inn',
    login_loading: 'Logger inn...',

    // LeadBoard
    leadboard_title: 'Leads',
    leadboard_subtitle: 'Følg opp kvalifiserte innringere — flytt mellom steg etter hvert som du jobber dem.',
    leadboard_refresh: 'Oppdater',
    leadboard_filter_hot_only: 'Kun hot leads (score ≥ 7)',
    leadboard_period: 'Periode:',
    leadboard_last_7: 'Siste 7 dager',
    leadboard_last_14: 'Siste 14 dager',
    leadboard_last_30: 'Siste 30 dager',
    leadboard_last_60: 'Siste 60 dager',
    leadboard_last_90: 'Siste 90 dager',
    leadboard_total_suffix: 'leads totalt',
    leadboard_col_ny: 'Ny',
    leadboard_col_kontaktet: 'Kontaktet',
    leadboard_col_avtalt: 'Avtalt',
    leadboard_col_lukket: 'Lukket',
    leadboard_unknown_caller: 'Ukjent innringer',
    leadboard_call_back: 'Ring tilbake',
    leadboard_next_step: 'Neste steg',
    leadboard_move_to: 'Flytt til',
    leadboard_set_status_to: 'Sett status til',
    leadboard_moved_to: 'Lead flyttet til',
    leadboard_load_error: 'Kunne ikke laste leads',
    leadboard_update_error: 'Kunne ikke oppdatere status',
    leadboard_empty_column: 'Ingen leads i denne kolonnen ennå.',
    leadboard_scroll_hint: '← sveip for flere kolonner →',

    // QualityDashboard
    quality_title: 'Samtalekvalitet',
    quality_subtitle: 'Samtaler hvor du har gitt 👎. Bruk innsikten til å forbedre AI-agenten.',
    quality_load_error: 'Kunne ikke laste kvalitetsdata',
    quality_empty_title: 'Ingen dårlige samtaler',
    quality_empty_subtitle: 'Bra jobbet! Ingen samtaler er flagget som dårlige.',
    quality_col_date: 'Dato',
    quality_col_caller: 'Innringer',
    quality_col_duration: 'Varighet',
    quality_col_rating: 'Vurdering',
    quality_col_comment: 'Kommentar',
    quality_rating_bad: 'Dårlig',
    quality_no_comment: 'Ingen kommentar',
    quality_row_aria: 'Vis samtaledetaljer',

    // UsageForecast
    usage_forecast_title: 'Forbruksprognose',
    usage_forecast_unlimited: 'ubegrenset',
    usage_forecast_of: 'av',
    usage_forecast_calls_used: 'samtaler brukt',
    usage_forecast_day: 'Dag',
    usage_forecast_used_so_far: 'brukt så langt',
    usage_forecast_days_remaining: 'dager igjen av måneden',
    usage_forecast_eom_estimate: 'Estimat ved månedsslutt',
    usage_forecast_calls_word: 'samtaler',
    usage_forecast_avg_based_on: 'Basert på snitt på',
    usage_forecast_calls_per_day: 'samtaler/dag',
    usage_forecast_overage_label: 'Estimert overforbruk',
    usage_forecast_per_extra_call: 'kr per ekstra samtale',
    usage_forecast_within_plan: 'Innenfor planen',
    usage_forecast_no_extra_costs: 'Ingen ekstra kostnader forventet denne måneden.',

    // Knowledge Base (AgentConfigPage)
    kb_load_error: 'Kunne ikke laste kunnskapsbase',
    kb_max: 'Maks',
    kb_max_lower: 'maks',
    kb_services_word: 'tjenester',
    kb_questions_word: 'spørsmål',
    kb_info_fields_word: 'info-felter',
    kb_saved_synced: 'Kunnskapsbase lagret og synkronisert til AI-agenten',
    kb_saved_sync_failed: 'Lagret, men sync til AI-agent feilet — prøv igjen senere',
    kb_saved: 'Kunnskapsbase lagret',
    kb_save_error: 'Kunne ikke lagre kunnskapsbase',
    kb_intro: 'Strukturert kunnskap som AI-agenten bruker når den svarer innringere. Endringer synkroniseres til agenten når du lagrer.',
    kb_services_title: 'Tjenester',
    kb_services_subtitle: 'Hva tilbyr bedriften?',
    kb_add_service: 'Legg til tjeneste',
    kb_no_services: 'Ingen tjenester lagt til ennå.',
    kb_service_name_ph: 'Tjenestenavn',
    kb_service_desc_ph: 'Kort beskrivelse',
    kb_remove: 'Fjern',
    kb_remove_entry_aria: 'Fjern oppføring',
    kb_faqs_title: 'Vanlige spørsmål',
    kb_faqs_subtitle: 'Spørsmål og svar',
    kb_add_qa: 'Legg til Q&A',
    kb_no_faqs: 'Ingen spørsmål lagt til ennå.',
    kb_question_ph: 'Spørsmål',
    kb_answer_ph: 'Svar',
    kb_info_title: 'Viktig info',
    kb_info_subtitle: 'Adresse, parkering, betaling osv.',
    kb_add_info: 'Legg til info',
    kb_no_info: 'Ingen info-felter lagt til ennå.',
    kb_info_key_ph: 'F.eks. Adresse',
    kb_info_value_ph: 'Verdi',
    kb_preview: 'Forhåndsvisning',
    kb_nothing_to_preview: 'Ingenting å forhåndsvise ennå.',
    kb_last_synced: 'Sist synkronisert:',
    kb_not_synced: 'Ikke synkronisert ennå',
    kb_unsaved_changes: 'Ulagrede endringer',
    kb_saving: 'Lagrer...',
    kb_save_button: 'Lagre og synkroniser',

    // Go-live card error
    go_live_error: 'Kunne ikke laste status',
    go_live_error_sub: 'Prøv igjen om et øyeblikk.',
    go_live_retry: 'Prøv igjen',

    // Misc
    loading: 'Laster...',
    error: 'Noe gikk galt',
    back: 'Tilbake',
    save: 'Lagre',
    cancel: 'Avbryt',
    delete: 'Slett',
    edit: 'Rediger',
    search: 'Søk',
    unknown: 'Ukjent',
    yes: 'Ja',
    no_word: 'Nei',
    min: 'min',
    sec: 'sek',
    page: 'Side',
    of: 'av',
    showing: 'Viser',
    results: 'resultater',
  },

  en: {
    // Nav / Sidebar
    nav_overview: 'Overview',
    nav_calls: 'Calls',
    nav_contacts: 'Contacts',
    nav_analytics: 'Analytics',
    nav_settings: 'Settings',
    nav_companies: 'Companies',
    nav_users: 'Users',
    nav_finance: 'Finance',
    nav_integrations: 'Integrations',
    nav_logout: 'Log out',

    // Dashboard
    dash_title: 'Overview',
    dash_total_calls: 'Total calls',
    dash_avg_score: 'Average lead score',
    dash_avg_duration: 'Average call duration',
    dash_appointments: 'Appointments booked',
    dash_hot_leads: 'Hot leads',
    dash_recent_calls: 'Recent calls',
    dash_no_calls: 'No calls yet',
    dash_lead_score: 'Lead score',
    dash_intent: 'Intent',
    dash_duration: 'Duration',
    dash_caller: 'Caller',
    dash_textbacks: 'Text-backs sent',
    dash_calls_per_day: 'Calls per day',
    dash_view_all: 'View all',
    dash_quick_latest_call: 'Latest call',
    dash_quick_latest_call_sub: 'See latest call',
    dash_quick_export_week: 'Export week',
    dash_quick_export_week_sub: 'Download CSV',
    dash_quick_contacts: 'All contacts',
    dash_quick_contacts_sub: 'Browse contact list',
    dash_quick_analytics: 'Analytics',
    dash_quick_analytics_sub: 'Trends and insights',
    dash_today_calls: "Today's calls",
    upgrade: 'Upgrade',

    // Calls
    calls_title: 'Calls',
    calls_search: 'Search calls...',
    calls_filter_all: 'All',
    calls_filter_hot: 'Hot leads',
    calls_filter_appt: 'Appointments',
    calls_no_results: 'No calls found',
    calls_score: 'Score',
    calls_intent: 'Intent',
    calls_duration: 'Duration',
    calls_date: 'Date',
    calls_caller: 'Caller',
    calls_summary: 'Summary',
    calls_transcript: 'Transcript',
    calls_back: 'Back',
    calls_export: 'Export CSV',
    calls_exporting: 'Exporting...',
    calls_export_success: 'CSV exported',
    calls_export_error: 'Could not export CSV',

    // Contacts
    contacts_title: 'Contacts',
    contacts_search: 'Search by name, phone or email...',
    contacts_add: 'Add contact',
    contacts_import: 'Import CSV',
    contacts_no_results: 'No contacts found',
    contacts_name: 'Name',
    contacts_phone: 'Phone',
    contacts_email: 'Email',
    contacts_calls: 'Calls',
    contacts_last_call: 'Last call',
    contacts_score: 'Score',
    contacts_tags: 'Tags',
    contacts_notes: 'Notes',
    contacts_history: 'Call history',
    contacts_back: 'Back',
    contacts_save: 'Save',
    contacts_export: 'Export CSV',
    contacts_exporting: 'Exporting...',
    contacts_export_error: 'Could not export contacts',
    contacts_total: '{count} contacts total',

    // Analytics
    analytics_title: 'Analytics',
    analytics_period: 'Period',
    analytics_7d: '7 days',
    analytics_30d: '30 days',
    analytics_90d: '90 days',
    analytics_calls_over_time: 'Calls over time',
    analytics_by_intent: 'By intent',
    analytics_by_score: 'By score',
    analytics_top_services: 'Top requested services',
    analytics_conversion: 'Conversion rate',
    analytics_no_data: 'No data for selected period',

    // Settings
    settings_title: 'Settings',
    settings_business: 'Business information',
    settings_hours: 'Business hours',
    settings_services: 'Services',
    settings_pricing: 'Pricing',
    settings_notifications: 'Notifications',
    settings_sms: 'SMS alerts',
    settings_email_notif: 'Email alerts',
    settings_save: 'Save',
    settings_saved: 'Saved',
    settings_error: 'Error saving',

    // Suggestions
    suggestions_title: 'Follow-Up Suggestions',
    suggestions_analyzing: 'Analyzing call...',
    suggestions_markDone: 'Mark done',
    suggestions_dismiss: 'Dismiss',
    suggestions_pending: 'follow-ups pending',
    suggestions_noPending: 'No pending follow-ups',

    // ROI
    roi_title: 'ROI Report',
    roi_subtitle: 'See the value your AI receptionist creates',
    roi_calls_handled: 'Calls Handled by AI',
    roi_hours_saved: 'Hours Saved',
    roi_cost_saved: 'Est. Cost Saved',
    roi_missed_recovered: 'Missed Calls Recovered',
    roi_this_month: 'this month',
    roi_total: 'total',
    roi_trend: 'Monthly Trend (Last 6 Months)',
    roi_suggestions_done: 'Follow-ups Completed',
    roi_suggestions_dismissed: 'Follow-ups Dismissed',
    roi_suggestions_pending: 'Pending',
    roi_hourly_rate_note: 'Calculated at',
    roi_hourly_rate_suffix: '/hr',
    roi_edit_settings: 'Edit in Settings',
    roi_share: 'Share Report',
    roi_nav: 'ROI',
    roi_hourly_rate_label: 'Hourly Rate (USD)',
    product_name: 'AI Reception',

    // Login
    login_headline: 'Your AI receptionist,<br/>always available.',
    login_subtext: 'Manage calls, leads and appointments from one place. See what\'s happening with your business in real time.',
    login_stat_always: 'Always on',
    login_stat_satisfied: 'Satisfied customers',
    login_stat_calls: 'Calls handled',
    login_title: 'Log in',
    login_subtitle: 'Enter your email and password to log in.',
    login_email: 'Email',
    login_email_placeholder: 'you@company.com',
    login_password: 'Password',
    login_password_placeholder: 'Your password',
    login_remember: 'Remember me',
    login_forgot: 'Forgot password?',
    login_forgot_alert: 'Contact us to reset your password.',
    login_button: 'Log in',
    login_loading: 'Logging in...',

    // LeadBoard
    leadboard_title: 'Leads',
    leadboard_subtitle: 'Follow up qualified callers — move between stages as you work them.',
    leadboard_refresh: 'Refresh',
    leadboard_filter_hot_only: 'Hot leads only (score ≥ 7)',
    leadboard_period: 'Period:',
    leadboard_last_7: 'Last 7 days',
    leadboard_last_14: 'Last 14 days',
    leadboard_last_30: 'Last 30 days',
    leadboard_last_60: 'Last 60 days',
    leadboard_last_90: 'Last 90 days',
    leadboard_total_suffix: 'leads total',
    leadboard_col_ny: 'New',
    leadboard_col_kontaktet: 'Contacted',
    leadboard_col_avtalt: 'Booked',
    leadboard_col_lukket: 'Closed',
    leadboard_unknown_caller: 'Unknown caller',
    leadboard_call_back: 'Call back',
    leadboard_next_step: 'Next step',
    leadboard_move_to: 'Move to',
    leadboard_set_status_to: 'Set status to',
    leadboard_moved_to: 'Lead moved to',
    leadboard_load_error: 'Could not load leads',
    leadboard_update_error: 'Could not update status',
    leadboard_empty_column: 'No leads in this column yet.',
    leadboard_scroll_hint: '← swipe for more columns →',

    // QualityDashboard
    quality_title: 'Call Quality',
    quality_subtitle: 'Calls you rated 👎. Use the insight to improve the AI agent.',
    quality_load_error: 'Could not load quality data',
    quality_empty_title: 'No bad calls',
    quality_empty_subtitle: 'Nice work! No calls flagged as bad.',
    quality_col_date: 'Date',
    quality_col_caller: 'Caller',
    quality_col_duration: 'Duration',
    quality_col_rating: 'Rating',
    quality_col_comment: 'Comment',
    quality_rating_bad: 'Bad',
    quality_no_comment: 'No comment',
    quality_row_aria: 'View call details',

    // UsageForecast
    usage_forecast_title: 'Usage forecast',
    usage_forecast_unlimited: 'unlimited',
    usage_forecast_of: 'of',
    usage_forecast_calls_used: 'calls used',
    usage_forecast_day: 'Day',
    usage_forecast_used_so_far: 'used so far',
    usage_forecast_days_remaining: 'days remaining this month',
    usage_forecast_eom_estimate: 'End-of-month estimate',
    usage_forecast_calls_word: 'calls',
    usage_forecast_avg_based_on: 'Based on average of',
    usage_forecast_calls_per_day: 'calls/day',
    usage_forecast_overage_label: 'Estimated overage',
    usage_forecast_per_extra_call: 'NOK per extra call',
    usage_forecast_within_plan: 'Within plan',
    usage_forecast_no_extra_costs: 'No extra costs expected this month.',

    // Knowledge Base (AgentConfigPage)
    kb_load_error: 'Could not load knowledge base',
    kb_max: 'Max',
    kb_max_lower: 'max',
    kb_services_word: 'services',
    kb_questions_word: 'questions',
    kb_info_fields_word: 'info fields',
    kb_saved_synced: 'Knowledge base saved and synced to AI agent',
    kb_saved_sync_failed: 'Saved, but sync to AI agent failed — try again later',
    kb_saved: 'Knowledge base saved',
    kb_save_error: 'Could not save knowledge base',
    kb_intro: 'Structured knowledge the AI agent uses when answering callers. Changes sync to the agent when you save.',
    kb_services_title: 'Services',
    kb_services_subtitle: 'What does the business offer?',
    kb_add_service: 'Add service',
    kb_no_services: 'No services added yet.',
    kb_service_name_ph: 'Service name',
    kb_service_desc_ph: 'Short description',
    kb_remove: 'Remove',
    kb_remove_entry_aria: 'Remove entry',
    kb_faqs_title: 'FAQs',
    kb_faqs_subtitle: 'Questions and answers',
    kb_add_qa: 'Add Q&A',
    kb_no_faqs: 'No questions added yet.',
    kb_question_ph: 'Question',
    kb_answer_ph: 'Answer',
    kb_info_title: 'Important info',
    kb_info_subtitle: 'Address, parking, payment, etc.',
    kb_add_info: 'Add info',
    kb_no_info: 'No info fields added yet.',
    kb_info_key_ph: 'E.g. Address',
    kb_info_value_ph: 'Value',
    kb_preview: 'Preview',
    kb_nothing_to_preview: 'Nothing to preview yet.',
    kb_last_synced: 'Last synced:',
    kb_not_synced: 'Not synced yet',
    kb_unsaved_changes: 'Unsaved changes',
    kb_saving: 'Saving...',
    kb_save_button: 'Save and sync',

    // Go-live card error
    go_live_error: 'Could not load status',
    go_live_error_sub: 'Try again in a moment.',
    go_live_retry: 'Retry',

    // Misc
    loading: 'Loading...',
    error: 'Something went wrong',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    unknown: 'Unknown',
    yes: 'Yes',
    no_word: 'No',
    min: 'min',
    sec: 'sek',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    results: 'results',
  },
};

export function t(lang, key, fallback) {
  const dict = translations[lang] || translations.no;
  return dict[key] || fallback || key;
}
